<template>
  <div class="stock-dashboard-list">
    <table class="overview-table">
      <thead>
        <tr>
          <th>{{ i18n.t('/StockDashboard/Table/Name') }}</th>
          <th>{{ i18n.t('/StockDashboard/Table/Specs') }}</th>
          <th>{{ i18n.t('/StockDashboard/Table/Status') }}</th>
          <th>{{ i18n.t('/StockDashboard/Table/Location') }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-if="stockCars.length">
          <tr
            v-for="stockCar in stockCars"
            :key="stockCar.Id"
            class="js-track-click"
            data-action="select-stock-car"
            @click="selectStockCar(stockCar, $event)"
          >
            <td>
              <strong>
                {{ stockCar.Configuration.ModelName }}
                {{ stockCar.Configuration.TrimlineName }}
              </strong>
              <br />
              {{ stockCar.Configuration.CatalogCarName }} <br />
              {{ i18n.n(stockCar.Configuration.Price.Incl, 'currency') }}
              <br />{{ stockCar.Metadata.LastUpdatedOn }}
              <br />
              <span
                data-qa="stockcar-overview-komnumber"
                class="stockcar-overview-komnumber table__meta-data"
              >
                {{ i18n.t('/StockDashboard/Table/Komnummer') }}
                {{ stockCar.StockCarDetails.KomNumber.Number }}<br />
                {{ stockCar.StockCarDetails.UnloadDate }}
              </span>
            </td>
            <td>
              {{ stockCar.Configuration.Color.Name }}<br />
              {{ stockCar.Configuration.Interior.Upholstery.Name }}
              {{ stockCar.Configuration.Interior.UpholsteryColor.Name }}<br />
              {{ stockCar.Configuration.Rim.Name }}<br />

              <span class="table__meta-data">{{ stockCar.Configuration.LicensePlate }}</span>
              <span v-if="stockCar.Configuration.Vin" class="table__meta-data">
                | {{ i18n.t('/StockDashboard/Detail/Vin') }} {{ stockCar.Configuration.Vin }}</span
              >
            </td>
            <td>
              {{ stockCar.StockCarDetails.Status }}
              <div v-if="stockCar.Reservation" class="stock-status-wrapper">
                {{ i18n.t('/StockDashboard/Table/StatusVOF') }}:
                {{
                  stockCar.Reservation.StatusIds.Status === ReservationStatus.available
                    ? i18n.t('/StockDashboard/Table/Available')
                    : i18n.t('/StockDashboard/Table/ReservedBlocked')
                }}<br />
                {{ i18n.t('/StockDashboard/Table/StatusSyntec') }}:
                {{
                  stockCar.Reservation.StatusSyntec &&
                  (stockCar.Reservation.StatusSyntec.Reserved ||
                    stockCar.Reservation.StatusSyntec.SoldSubjectToFinancing)
                    ? i18n.t('/StockDashboard/Table/Reserved')
                    : i18n.t('/StockDashboard/Table/Available')
                }}<br />
                <span class="tooltip">
                  <span>{{ i18n.t('/StockDashboard/Table/Information') }}:</span>
                  <app-tooltip
                    :title="i18n.t('/StockDashboard/ReservationStatus/Title')"
                    class="stock-status-tooltip"
                    large
                  >
                    <stock-reservation-status :stock-car-id="stockCar.Id" />
                  </app-tooltip>
                </span>
              </div>
            </td>
            <td>{{ stockCar.StockCarDetails.Establishment }}</td>
          </tr>
        </template>
        <tr v-if="!isLoading && !stockCars.length">
          <td colspan="4">{{ i18n.t('/StockDashboard/Table/NoCarsFound') }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import StockReservationStatus from '@/components/generic/presentational/molecules/stockReservationStatus/StockReservationStatus.vue'
import StoreConnector from '@/helpers/StoreConnector'
import AppTooltip from '@/components/generic/presentational/molecules/appTooltip/AppTooltip.vue'
import ReservationStatus from '@/helpers/enums/reservationStatus'

const PAGE_SIZE = 3

export default {
  components: {
    StockReservationStatus,
    AppTooltip,
  },
  props: {
    reservationStatuses: {
      type: Array,
      default: null,
    },
  },
  emits: ['selectStockCar'],
  data() {
    return {
      isLoading: false,
      stockCars: [],
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      currentPage: 1,
      ReservationStatus,
    }
  },
  computed: {
    shouldLoadMore() {
      return !this.isLoading && PAGE_SIZE * this.currentPage <= this.stockCars.length
    },
    filterReserved() {
      return this.reservationStatuses.some((x) => x.startsWith(ReservationStatus.unavailable))
    },
  },
  created() {
    StoreConnector.get('stockcars/stockcars', (data) => {
      this.stockCars = data
    })
    StoreConnector.get('stockcars/isLoading', (data) => {
      this.isLoading = data
    })
  },
  methods: {
    loadMore() {
      StoreConnector.dispatch('stockcars/updateCurrentPage')
    },
    selectStockCar(stockCar, event) {
      if (event.target.closest('.tooltip')) return
      if (event.target.closest('button[data-action="close"]')) return
      const { ModelName, TrimlineName } = stockCar.Configuration
      const title = `${ModelName} ${TrimlineName}`

      this.$emit('selectStockCar', {
        title,
        stockCarId: stockCar.Id,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip {
  display: flex;
  align-items: center;
}

table {
  margin-bottom: 1em;
}

.stock-dashboard-list {
  margin-bottom: 1em;
  .overview-table {
    td:nth-child(3),
    th:nth-child(3) {
      width: 16rem;
    }
  }
}
</style>
